import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=75666b23&class=dense%20hidden-sm-and-down&"
import script from "./Spacer.vue?vue&type=script&lang=js&"
export * from "./Spacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports